import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
  standalone: false,
  templateUrl: 'pdf-printable.component.html'
})

export class PdfPrintableComponent implements OnInit {

  eventoData: { alumnos: any[], materia: any, eventoId: number };

  fechas;
  isRubrica = false;
  isComentario = false;

  onPrint = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<PdfPrintableComponent>,
              @Inject(MAT_DIALOG_DATA) public data) {
  }

  ngOnInit() {
    this.eventoData = this.data;
    this.fechas = this.eventoData.materia.fechas.map((fecha, i) => ({checked: i === 0, fecha}));
  }

  buttonEnable() {
    return this.fechas.filter(fecha => fecha.checked).length > 0 && (this.isRubrica || this.isComentario);
  }

  print() {
    const fechas = this.fechas.filter(fecha => fecha.checked);
    this.onPrint.emit({
      fechas: fechas.map(fecha => moment(fecha.fecha)),
      isRubrica: this.isRubrica,
      isComentario: this.isComentario,
      alumnos: this.eventoData.alumnos.map(alumno => ({id: alumno.id})),
      eventoId: this.eventoData.eventoId
    });
  }
}
